import { setupWorker } from 'msw/browser';

import { handlersList } from './handlers';

export const worker = setupWorker(...handlersList);
